import { Field, ObjectType } from '@nestjs/graphql'

/**
 * A machine translation of a category's name. Deliberately just the two fields the UI needs:
 * every category carries all of its locales on every response, so the payload is kept small.
 */
@ObjectType()
export class CategoryTranslationDto {
  @Field()
  locale!: string

  @Field()
  name!: string
}
